import type { FlowkitSkillProvenanceData } from '../services/flowkitSkills';
import './FlowkitSkills.css';

export function FlowkitSkillProvenance({ provenance, notice }: {
  provenance?: FlowkitSkillProvenanceData;
  notice?: string;
}) {
  if (!provenance) return notice ? <p className="flowkit-skill-notice" role="note">{notice}</p> : null;
  const { loadedSkills, deferredSkills, warnings } = provenance;
  return (
    <section className="flowkit-skill-provenance" aria-label="Flowkit skill provenance">
      <p><strong>Flowkit skills · Planning only</strong></p>
      <p>{loadedSkills.length} loaded · {deferredSkills.length} deferred. No recipes were executed.</p>
      <details>
        <summary>Source details</summary>
        <p><strong>Loaded into planning context</strong></p>
        {loadedSkills.length ? <ul>{loadedSkills.map((skill, index) => (
          <li key={`${skill.id}-${index}`}><code>{skill.id}</code><br />SHA-256: <code>{skill.sha256}</code></li>
        ))}</ul> : <p>No recipe bodies were reported as loaded.</p>}
        <p><strong>Deferred — not loaded</strong></p>
        {deferredSkills.length ? <ul>{deferredSkills.map((id, index) => (
          <li key={`${id}-${index}`}><code>{id}</code></li>
        ))}</ul> : <p>None reported.</p>}
        <p>IDs and hashes are those reported for this request, not the current catalog.</p>
      </details>
      {warnings.length > 0 && <div className="flowkit-skill-warning" role="note">
        <strong>Planning warnings</strong>
        <ul>{warnings.map((warning, index) => <li key={index}>{warning}</li>)}</ul>
      </div>}
    </section>
  );
}